import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
  Checkbox,
  Radio,
  DatePicker,
} from "rsuite";
import { Form, Field } from "react-final-form";
import { render } from "react-dom";
import { UserServices } from "../../../core/services/UserServices";
import { RoleServices } from "../../../core/services/RoleServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import "./User.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  httpStatusArr,
  messageTypeArr,
  roleTypeArr,
  userTypeObjArr,
  onOffArr,
  statusArr,
  roleObjArr,
  genderArr,
  religionObj,
  religionObjArr,
  dayTimeObjArr,
  weekDaysObjArr,
  dateFormatObj,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "./../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  calenderDateToDB,
  dbDateToCalender,
  getHourMinuteFormat,
  getPrimaryAddress,
  isNotEmpty,
  isNotNull,
} from "../../../utils/helpers";
function NewUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const params: any = useParams();
  const selectedCompany = useSelector((state: any) => state.company);
  const [file, setFile] = useState<any>();
  const [updateUserImage, setUpdateUserImage] = useState("");
  const [idFile, setIdFile] = useState<any>();
  const [userIdProof, setUserIdProof] = useState("");
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areas, setAreas] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [formData, setFormData] = useState<any>({
    emp_code: "",
    email: "",
    name: "",
    fname: "",
    lname: "",
    mobile: "",
    username: "",
    password: "",
    confirm_password: "",
    role_id: "",
    store_id: "",
    comp_id: "",
    city_id: "",
    designation: "",
    gender: genderArr.male,
    religion: "",
    country_id: "",
    state_id: "",
    address_mobile: "",
    house_no: "",
    building: "",
    area_name: "",
    landmark: "",
    pincode: "",
    userType: "",
    skill_set: "",
    profile_details: "",
    work_start_time: "",
    work_end_time: "",
    week_off_day: "",
    beneficiary_memeber_details: "",
    relative1_details: "",
    relative2_details: "",
    birthday: "",
    joining_date: "",
    relieving_date: "",
    existing_employment_details: "",
    status: statusArr.active,
    receive_notification: onOffArr.on,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [cityNotFound, setCityNotFound] = useState(false);
  const [stateNotFound, setSateNotFound] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [isUsernameAllowed, setIsUsernameAllowed] = useState(true);
  const areaRef = useRef<any>();
  const buildingRef = useRef<any>();
  let [decryptedParams] = useDecryptedParams(params);
  const [userTypeSelected, setUserTypeSelected] = useState("");

  async function init() {
    try {
      if (decryptedParams.id) {
        const response: any = await UserServices.viewUser(+decryptedParams.id);
        const respData = get("data.data", response);
        const primaryAddress = getPrimaryAddress(respData);
        const empDetails = respData?.emp_details;

        let obj = { ...formData };
        if (respData.image_url) {
          setUpdateUserImage(respData.image_url);
        }
        if (respData?.user_id_proof_doc_url) {
          setUserIdProof(respData.user_id_proof_doc_url);
        }
        Object.keys(obj).map((formKeys) => {
          if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
          if (!respData[formKeys] && primaryAddress[formKeys]) {
            obj[formKeys] = primaryAddress[formKeys];
          }
          if (!respData[formKeys] && empDetails && empDetails[formKeys]) {
            obj[formKeys] = empDetails[formKeys];
          }

          if (formKeys === "status") {
            obj[formKeys] = respData.status.toString();
          }
          if (formKeys === "building") {
            obj[formKeys] = primaryAddress["building_name"];
          }
          if (formKeys === "address_mobile") {
            obj[formKeys] = primaryAddress["mobile"];
          }
          if (formKeys === "role_id") {
            obj[formKeys] = isNotEmpty(respData?.roles[0])
              ? respData?.roles[0]["id"]
              : "";
            if (
              isNotEmpty(respData?.roles[0]) &&
              respData.roles[0]["id"] == roleObjArr.store_admin.id
            ) {
              storeSearch("", respData["company_id"]);
            }
          }
          if (formKeys === "userType") {
            obj[formKeys] = respData["user_type"];
            setRoleTypeDynamically(respData["user_type"]);
          }

          if (
            ["birthday", "joining_date", "relieving_date"].includes(formKeys)
          ) {
            obj[formKeys] = dbDateToCalender(obj[formKeys]);
          } else if (["work_start_time", "work_end_time"].includes(formKeys)) {
            obj[formKeys] = getHourMinuteFormat(obj[formKeys]);
          }
        });

        setFormData({ ...obj });
        //console.log(formData);
        if (obj.country_id) {
          handleCountryChange(obj.country_id);
        }
        if (obj.state_id) {
          handleStateChange(obj.state_id);
        }
        if (obj.city_id && obj.state_id && obj.country_id) {
          searchArea("", obj.city_id);
          searchBuilding("", obj.city_id);
        }
      }
    } catch (error: any) {
      console.log(error);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });

      navigate(ContentRoutes.USERS);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  async function handleStateChange(stateId: any) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      const respData = get("data.data", res);
      setCityList(respData);
      setCityNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCountryChange(countryId: any) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      const respData = get("data.data", stateRes);
      setStateList(respData);
      setSateNotFound(!respData.length);
    } catch (error) {
      console.log(error);
    }
  }

  async function handleUserTypeChange(e: any, form: any) {
    form.change("userType", e);
    // form.change("store_id", "");
    setUserTypeSelected(e);
    delete form.getState().values.role_id;
    setRoles([]);
    setRoleTypeDynamically(e);
    if (e === roleTypeArr.client && (!selectedCompany || !selectedCompany.id)) {
      {
        UtilityServices.showToaster({
          message: t("PLEASE_SELECT_FIELD", {
            field: t("COMPANY").toLowerCase(),
          }),
          type: "warning",
        });
      }
      // do not use document , use redux for this.
      document.getElementById("top-company-dropdown")?.click();
    }
  }

  async function setRoleTypeDynamically(value: string) {
    if (!value) {
      return;
    }
    try {
      const res = await RoleServices.fetchDownRoles(value);
      const respData = get("data.data", res);
      if (respData.length) {
        setRoles(respData);
      }
    } catch (error: any) {
      setErrorMessage(error?.message);
    }
  }

  useEffect(() => {
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      setRoleTypeDynamically(roleTypeArr.client);
    }
  }, []);

  useEffect(() => {
    storeSearch("");
  }, [selectedCompany.id]);

  async function saveUser(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await UserServices.updateUser(+id, form);
      } else {
        response = await UserServices.createUser(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.USERS);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const dbounceUsername = useCallback(
    debounce(500, (value: string) => {
      checkUserName(value);
    }),
    []
  );

  const handleUsernameCheck = (value: string) => {
    dbounceUsername(value);
  };

  async function checkUserName(name: string) {
    if (decryptedParams.id) return;
    try {
      const res = await UserServices.checkUserNameAvailablity({
        username: name,
      });
      setIsUsernameAllowed(false);
    } catch (error: any) {
      setIsUsernameAllowed(true);
    }
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    console.log(formData);
    frmObj[frmIndex as keyof typeof frmObj] = date;
    console.log(frmObj);
    setFormData({ ...frmObj });
  };
  const dbounceArea = useCallback(
    debounce(1000, (searchAreaValue: string, cityId: any) => {
      searchArea(searchAreaValue, +cityId);
    }),
    []
  );

  const handleAreaSearch = (value: any, cityId: any) => {
    dbounceArea(value, cityId);
  };

  async function searchArea(search: string, cityId: number) {
    try {
      if (decryptedParams.id || search) {
        const res = await HelperServices.getAllValidAreas({
          city: cityId,
          smart_search: search,
        });
        setAreas(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const dbounceBuilding = useCallback(
    debounce(1000, (searchBuilValue: string, cityId: any, areaId?: any) => {
      searchBuilding(searchBuilValue, +cityId, +areaId);
    }),
    []
  );

  const handleBuilingSearch = (value: string, cityId: any, areaId?: any) => {
    dbounceBuilding(value, cityId, areaId);
  };

  async function searchBuilding(
    search: string,
    cityId: number,
    selectedAreaId?: any
  ) {
    try {
      if (decryptedParams.id || search.length > 2) {
        const res = await HelperServices.getAllValidBuildings({
          area: +selectedAreaId,
          city: +cityId,
          smart_search: search,
        });
        setBuildings(get("data.data", res));
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function storeSearch(searchStore: string, forComp?: number) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = forComp ? forComp : selectedCompany.id;
    }

    if (!compId) {
      return;
    }
    try {
      const res = await StoreServices.getStores({
        company: compId,
        smart_search: searchStore,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreList(respData);
      }
    } catch (error: any) {
      console.log(error);
    }
  }

  useEffect(() => {
    // hide area result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react
    function handleClickOutside(event: any) {
      if (areaRef.current && !areaRef.current.contains(event.target)) {
        setAreas([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [areaRef]);

  useEffect(() => {
    // hide building result on out side click
    //review comment: can we use onBlur on area field rather than adding a event listener on the whole window ? This is an anti pattern in react TP
    function handleClickOutsidebuilding(event: any) {
      if (buildingRef.current && !buildingRef.current.contains(event.target)) {
        setBuildings([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutsidebuilding);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsidebuilding);
    };
  }, [buildingRef]);

  const onSubmit = (val: any) => {
    const form = new FormData();
    const isEdit = Boolean(decryptedParams.id);
    const roleId = Number(form.get("role_id")?.valueOf());
    for (var key in formData) {
      const value = val[key];

      if (["birthday", "joining_date", "relieving_date"].includes(key)) {
        if (value) {
          form.append(key, calenderDateToDB(value));
        } else {
          if (isEdit) {
            form.append(key, "");
          }
        }
        continue;
      } else if (
        ["work_start_time", "work_end_time", "week_off_day"].includes(key)
      ) {
        form.append(key, getHourMinuteFormat(value));
        continue;
      }
      if (value !== undefined && value !== null && value !== "") {
        form.append(key, value);
      } else {
        if (isEdit) {
          form.append(key, "");
        }
      }
    }
    if (file) {
      form.append("image", file, file.name);
    }
    if (idFile) {
      form.append("id_proof_doc", idFile, idFile.name);
    }
    if (
      roleId &&
      ![roleObjArr.store_admin.id, roleObjArr.store_staff.id].includes(roleId)
    ) {
      form.delete("store_id");
    }
    if (form.get("userType") !== roleTypeArr.client) {
      form.delete("comp_id");
      form.delete("store_id");
    }
    form.delete("userType");
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      form.set("comp_id", UtilityServices.getLoggedInUser("company_id"));
    } else if (
      UtilityServices.getLoggedInUser("user_type") === roleTypeArr.backend &&
      userTypeSelected === roleTypeArr.client &&
      !selectedCompany.id
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    } else if (selectedCompany.id) {
      form.set("comp_id", selectedCompany.id);
    }

    if (decryptedParams.id) {
      form.delete("role_id");
      form.delete("comp_id");
      if (!form.get("password")) form.delete("password");
      if (!form.get("confirm_password")) form.delete("confirm_password");
      saveUser(form, decryptedParams.id);
    } else {
      saveUser(form);
    }
  };

  return (
    <div className="user">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content="Loading..."
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header mb-2">
          <h4>
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("USER")}
          </h4>
        </Header>
        <Content className="content user-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.fname) {
                errors.fname = t("REQUIRED", {
                  field: t("FIRST_NAME").toLowerCase(),
                });
              }
              if (!values.lname) {
                errors.lname = t("REQUIRED", {
                  field: t("LAST_NAME").toLowerCase(),
                });
              }
              if (!values.email) {
                errors.email = t("REQUIRED", {
                  field: t("EMAIL").toLowerCase(),
                });
              }
              if (
                !values.userType &&
                UtilityServices.getLoggedInUser("user_type") !==
                  roleTypeArr.client
              ) {
                errors.userType = t("PLEASE_SELECT_FIELD", {
                  field: t("USER_TYPE").toLowerCase(),
                });
              }
              if (!values.role_id) {
                errors.role_id = t("PLEASE_SELECT_FIELD", {
                  field: t("USER_ROLE").toLowerCase(),
                });
              }
              if (
                !values.store_id &&
                UtilityServices.getLoggedInUser("user_type") ===
                  roleTypeArr.client &&
                (values.role_id === roleObjArr.store_admin.id ||
                  values.role_id === roleObjArr.store_staff.id)
              ) {
                errors.store_id = t("PLEASE_SELECT_FIELD", {
                  field: t("STORE").toLowerCase(),
                });
              }
              if (!values.username) {
                errors.username = t("REQUIRED", {
                  field: t("USERNAME").toLowerCase(),
                });
              }
              if (values.username && values.username.length < 4) {
                errors.username = t("AT_LEAST", {
                  field: t("USERNAME"),
                  char: 4,
                });
              }
              if (!values.mobile) {
                errors.mobile = t("REQUIRED", {
                  field: t("MOBILE").toLowerCase(),
                });
              }
              if (values.mobile && values.mobile.length !== 10) {
                errors.mobile = t("VALID", {
                  entity: t("MOBILE").toLowerCase(),
                });
              }
              if (!params?.id) {
                if (!values.password) {
                  errors.password = t("REQUIRED", {
                    field: t("PASSWORD").toLowerCase(),
                  });
                }
                if (!values.confirm_password) {
                  errors.confirm_password = t("REQUIRED", {
                    field: t("CONFIRM_PASSWORD").toLowerCase(),
                  });
                }
              }
              if (!values.country_id) {
                errors.country_id = t("REQUIRED", {
                  field: t("COUNTRY").toLowerCase(),
                });
              }
              if (!values.state_id) {
                errors.state_id = t("REQUIRED", {
                  field: t("STATE").toLowerCase(),
                });
              }
              if (!values.city_id) {
                errors.city_id = t("REQUIRED", {
                  field: t("CITY").toLowerCase(),
                });
              }
              if (!values.area_name) {
                errors.area_name = t("REQUIRED", {
                  field: t("AREA").toLowerCase(),
                });
              }
              if (!values.building) {
                errors.building = t("REQUIRED", {
                  field: t("BUILDING").toLowerCase(),
                });
              }
              if (!values.house_no) {
                errors.house_no = t("REQUIRED", {
                  field: t("HOUSE_NO").toLowerCase(),
                });
              }
              if (!values.pincode) {
                errors.pincode = t("REQUIRED", {
                  field: t("PINCODE").toLowerCase(),
                });
              }
              if (
                values.address_mobile &&
                values.address_mobile?.length !== 10
              ) {
                errors.address_mobile = t("VALID", {
                  entity: t("MOBILE").toLowerCase(),
                });
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <div className="flex-container">
                  <Field name="image">
                    {({ input, meta }) => (
                      <div className="flex-item">
                        <div className="d-flex usr-img">
                          <div>
                            <img
                              className="usr-img-bx"
                              src={
                                file
                                  ? URL.createObjectURL(file)
                                  : updateUserImage
                                  ? updateUserImage
                                  : UtilityServices.getLoggedInUser(
                                      "user_default_image"
                                    )
                              }
                              alt={t("USER") + " " + t("IMAGE")}
                              title={t("USER") + " " + t("IMAGE")}
                            />
                          </div>
                          <input
                            id="image-upload"
                            {...input}
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChangeCapture={(e: any) => {
                              setFile(e.target.files[0]);
                            }}
                            style={{ display: "none" }}
                          />
                          <label
                            className="user-image-upload-lbl"
                            htmlFor="image-upload"
                          >
                            {t("UPLOAD")} {t("IMAGE")}
                          </label>
                        </div>
                      </div>
                    )}
                  </Field>
                  <Field name="id_proof_doc">
                    {({ input, meta }) => (
                      <div className="flex-item">
                        <div className="d-flex usr-img">
                          <div>
                            <img
                              className="usr-img-bx"
                              src={
                                idFile
                                  ? URL.createObjectURL(idFile)
                                  : userIdProof
                                  ? userIdProof
                                  : UtilityServices.getLoggedInUser(
                                      "user_default_image"
                                    )
                              }
                              alt={t("USER") + " " + t("ID") + " " + t("PROOF")}
                              title={
                                t("USER") + " " + t("ID") + " " + t("PROOF")
                              }
                            />
                          </div>
                          <input
                            id="id-doc-upload"
                            {...input}
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChangeCapture={(e: any) => {
                              setIdFile(e.target.files[0]);
                            }}
                            style={{ display: "none" }}
                          />
                          <label
                            className="id_proof_doc-lbl"
                            htmlFor="id-doc-upload"
                          >
                            {t("UPLOAD")} {t("ID")} {t("PROOF")}
                          </label>
                        </div>
                      </div>
                    )}
                  </Field>
                </div>

                <div className="form-part">
                  <div className="flex-container">
                    <Field
                      name="fname"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("FIRST_NAME")}*</label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="lname"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LAST_NAME")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="email"
                      validate={ValidatorCustom.emailPatternValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("EMAIL")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="username"
                      validate={ValidatorCustom.whiteSpacePatterValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("USERNAME")}*</label>
                          <input
                            {...input}
                            type="text"
                            autoComplete="off"
                            onChangeCapture={(e: any) => {
                              let val = e.target.value;
                              if (val && val.length > 3) {
                                handleUsernameCheck(val);
                              }
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {!meta.error &&
                            meta.touched &&
                            !isUsernameAllowed && (
                              <span>
                                {t("USERNAME_VALIDATION", {
                                  value: t(input.value),
                                })}
                              </span>
                            )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field
                      name="mobile"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("MOBILE")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="designation"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("DESIGNATION")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="gender">
                      {({ input, meta }) => (
                        <div className="flex-item gndr-item">
                          <label>{t("GENDER")}</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.male);
                              }
                            }}
                            checked={
                              input.value === genderArr.male ? true : false
                            }
                            name="gender"
                            value={genderArr.male}
                          >
                            {t("MALE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.female);
                              }
                            }}
                            checked={
                              input.value === genderArr.female ? true : false
                            }
                            name="gender"
                            value={genderArr.female}
                          >
                            {t("FEMALE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("gender", genderArr.trans_gender);
                              }
                            }}
                            checked={
                              input.value === genderArr.trans_gender
                                ? true
                                : false
                            }
                            name="gender"
                            value={genderArr.trans_gender}
                          >
                            {t("TRANS_GENDER")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="religion">
                      {({
                        input,
                        meta,
                        options = religionObjArr,
                        isEdit = params?.id ? true : false,
                      }) => (
                        <div className="flex-item">
                          <label>{t("RELIGION")}*</label>
                          <CustomSelector
                            valueKey="value"
                            labelKey="label"
                            defaultValue={input.value}
                            listData={options}
                            onClear={(event: any) => {
                              form.change("religion", "");
                            }}
                            onChange={(e: any) => {
                              form.change("religion", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  {
                    /*!params?.id*/ 1 == 1 && (
                      <div className="flex-container">
                        <Field
                          name="password"
                          validate={ValidatorCustom.passwordPatternValidator}
                        >
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>{t("PASSWORD")}*</label>
                              <input
                                {...input}
                                type="password"
                                autoComplete="off"
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name="confirm_password">
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("CONFIRM")} {t("PASSWORD")}*
                              </label>
                              <input
                                {...input}
                                type="password"
                                autoComplete="off"
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                              {!meta.error &&
                                meta.touched &&
                                form.getState().values.password &&
                                form.getState().values.password !==
                                  form.getState().values.confirm_password && (
                                  <>
                                    <br />
                                    <span>
                                      {t("DOES_NOT_MATCH", {
                                        field1: t("CONFIRM_PASSWORD"),
                                        field2: t("PASSWORD").toLowerCase(),
                                      })}
                                    </span>
                                  </>
                                )}
                            </div>
                          )}
                        </Field>
                        <div className="flex-item"></div>
                      </div>
                    )
                  }
                  <div className="flex-container">
                    <Field name="userType">
                      {({
                        input,
                        meta,
                        options = userTypeObjArr,
                        isEdit = params?.id ? true : false,
                      }) => (
                        <div className="flex-item">
                          <label>{t("USER_TYPE")}*</label>
                          <CustomSelector
                            valueKey="value"
                            labelKey="label"
                            isDisable={
                              UtilityServices.getLoggedInUser("user_type") ===
                                roleTypeArr.client || isEdit
                            }
                            defaultValue={
                              UtilityServices.getLoggedInUser("user_type") ===
                              roleTypeArr.client
                                ? roleTypeArr.client
                                : input.value
                            }
                            onClear={(event: any) => {
                              setUserTypeSelected("");
                              delete form.getState().values.role_id;
                              delete form.getState().values.userType;
                              setRoles([]);
                            }}
                            listData={options}
                            onChange={(e: any) => {
                              //move this code to a function
                              form.change("userType", e);
                              // form.change("store_id", "");
                              setUserTypeSelected(e);
                              delete form.getState().values.role_id;
                              setRoles([]);
                              setRoleTypeDynamically(e);
                              if (
                                e === roleTypeArr.client &&
                                (!selectedCompany || !selectedCompany.id)
                              ) {
                                {
                                  UtilityServices.showToaster({
                                    message: t("PLEASE_SELECT_FIELD", {
                                      field: t("COMPANY").toLowerCase(),
                                    }),
                                    type: "warning",
                                  });
                                }
                                // do not use document , use redux for this.
                                document
                                  .getElementById("top-company-dropdown")
                                  ?.click();
                              }
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="role_id">
                      {({
                        input,
                        meta,
                        options = roles,
                        isEdit = params?.id ? true : false,
                      }) => (
                        <div className="flex-item">
                          <label>{t("USER_ROLE")}*</label>
                          <CustomSelector
                            valueKey="id"
                            labelKey="label"
                            defaultValue={input.value}
                            isDisable={!options.length || isEdit}
                            listData={options.length ? options : [{}]}
                            onClear={(event: any) => {
                              form.change("role_id", "");
                              form.change("store_id", "");
                            }}
                            onChange={(e: any) => {
                              form.change("store_id", "");
                            }}
                            onSelect={(e: any) => {
                              // again move this to a new function
                              form.change("role_id", e);
                              if (
                                (e === roleObjArr.store_admin.id ||
                                  e === roleObjArr.store_staff.id) &&
                                selectedCompany &&
                                selectedCompany.id
                              ) {
                                //storeSearch("");
                                // do not use document , use redux for this.
                                document
                                  .getElementById("store_selector")
                                  ?.click();
                              }
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    {(form.getState().values?.role_id ===
                      roleObjArr.store_admin.id ||
                      form.getState().values?.role_id ===
                        roleObjArr.store_staff.id) && (
                      <Field name="store_id">
                        {({ input, meta, options = storeList }) => (
                          <div className="flex-item">
                            <label>{t("STORE")}</label>
                            <SelectPicker
                              onOpen={() => storeSearch("")}
                              onSearch={(e: any) => e && storeSearch(e)}
                              onSelect={(e: any) => form.change("store_id", e)}
                              onClean={() => form.change("store_id", "")}
                              id="store_selector"
                              valueKey="id"
                              labelKey="store_name"
                              data={options}
                              defaultValue={input.value}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    )}
                  </div>
                  <div className="flex-container">
                    <Field
                      name="emp_code"
                      validate={ValidatorCustom.isAlphaNumericPatternValidator}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("EMPLOYEE_CODE")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="receive_notification">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="inline">
                            {t("RECEIVE_NOTIFICATION")}*
                          </label>
                          <Checkbox
                            name="receive_notification"
                            checked={input.value === onOffArr.on ? true : false}
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change(
                                  "receive_notification",
                                  onOffArr.on
                                );
                              }
                            }}
                            value={onOffArr.on}
                          >
                            {t("YES")}
                          </Checkbox>
                          <Checkbox
                            checked={
                              input.value === onOffArr.off ? true : false
                            }
                            name="receive_notification"
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change(
                                  "receive_notification",
                                  onOffArr.off
                                );
                              }
                            }}
                            value={onOffArr.off}
                          >
                            {t("NO")}
                          </Checkbox>
                        </div>
                      )}
                    </Field>
                    <Field name="status">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="inline">{t("STATUS")}*</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", statusArr.active);
                              }
                            }}
                            checked={
                              input.value === statusArr.active ? true : false
                            }
                            name="status"
                            value={statusArr.active}
                          >
                            {t("ACTIVE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", statusArr.inactive);
                              }
                            }}
                            checked={
                              input.value === statusArr.inactive ? true : false
                            }
                            name="status"
                            value={statusArr.inactive}
                          >
                            {t("INACTIVE")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="address-bx">
                  <h5>{t("ADDRESS")}</h5>
                </div>
                <div className="form-part">
                  <div className="flex-container">
                    <Field name="country_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field: t("COUNTRY").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="id"
                            labelKey="country_name"
                            isDisable={!countryList?.length ? true : false}
                            labelName={t("COUNTRY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("country_id", "");
                              form.change("state_id", "");
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                              setStateList([]);
                              setCityList([]);
                            }}
                            listData={countryList?.length ? countryList : []}
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("country_id", e);
                              handleCountryChange(e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="state_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.country_id &&
                              !stateList?.length
                                ? t("FETCHING_DATA_OF", {
                                    field: t("STATE").toLocaleLowerCase(),
                                  })
                                : ""
                            }
                            valueKey="id"
                            labelKey="state_name"
                            isRequired={true}
                            isDisable={!stateList?.length ? true : false}
                            labelName={t("STATE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("state_id", "");
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                              setCityList([]);
                            }}
                            listData={
                              form.getState().values.country_id &&
                              stateList?.length
                                ? stateList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("state_id", e);
                              handleStateChange(e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.country_id &&
                            !stateList?.length && <br />}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            !stateNotFound && (
                              <span>
                                {t("FETCHING_DATA_OF", { field: t("STATE") })}
                              </span>
                            )}
                          {form.getState().values.country_id &&
                            !stateList?.length &&
                            stateNotFound && (
                              <span>
                                {t("NO_DATA_FOUND_OF", {
                                  field: t("STATE").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                        </div>
                      )}
                    </Field>
                    <Field name="city_id">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={
                              form.getState().values.state_id &&
                              !cityList?.length
                                ? t("FETCHING_DATA_OF", { field: t("CITY") })
                                : ""
                            }
                            valueKey="id"
                            labelKey="city_name"
                            isRequired={true}
                            isDisable={!cityList?.length ? true : false}
                            labelName={t("CITY")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("city_id", "");
                              form.change("building", "");
                              form.change("area_name", "");
                            }}
                            listData={
                              form.getState().values.state_id &&
                              cityList?.length
                                ? cityList
                                : [{}]
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("city_id", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                          {meta.error &&
                            meta.touched &&
                            form.getState().values.state_id &&
                            !cityList?.length && <br />}
                          {form.getState().values.state_id &&
                            !cityList?.length &&
                            !cityNotFound && (
                              <span>
                                {t("FETCHING_DATA_OF", {
                                  field: t("CITY").toLocaleLowerCase(),
                                })}
                              </span>
                            )}
                          {form.getState().values.state_id && cityNotFound && (
                            <span>
                              {t("NO_DATA_FOUND_OF", {
                                field: t("CITY").toLocaleLowerCase(),
                              })}
                            </span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="house_no">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("HOUSE_NO")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="area_name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item" ref={areaRef}>
                          <label>{t("AREA")}*</label>
                          <input
                            {...input}
                            type="text"
                            disabled={
                              form.getState().values.city_id ? false : true
                            }
                            autoComplete="off"
                            onChange={(event: any) => {
                              handleAreaSearch(
                                event.target.value,
                                form.getState().values.city_id
                              );
                              form.change("area_name", event.target.value);
                            }}
                          />
                          {meta.modified && areas && areas.length ? (
                            <div className="tarea-nm-bx">
                              {areas &&
                                areas.length &&
                                areas.map((area: any, index) => {
                                  return (
                                    <div key={index}>
                                      <label
                                        className="tarea-nm-lbl"
                                        onClick={(e: any) => {
                                          form.change(
                                            "area_name",
                                            area.area_name
                                          );
                                          setSelectedAreaId(area.id);
                                          setAreas([]);
                                        }}
                                      >
                                        {area && area.area_name}
                                      </label>{" "}
                                      <br />
                                    </div>
                                  );
                                })}
                            </div>
                          ) : null}
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="building"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item" ref={buildingRef}>
                          <label>{t("BUILDING")}*</label>
                          <input
                            {...input}
                            type="text"
                            disabled={
                              form.getState().values.city_id ? false : true
                            }
                            autoComplete="off"
                            onChange={(event: any) => {
                              handleBuilingSearch(
                                event.target.value,
                                form.getState().values.city_id,
                                selectedAreaId
                              );
                              form.change("building", event.target.value);
                            }}
                          />
                          {meta.modified && buildings?.length ? (
                            <div className="tarea-nm-bx">
                              {meta.touched &&
                                buildings?.length &&
                                buildings.map((building: any, index) => {
                                  return (
                                    <div key={index}>
                                      <label
                                        className="tarea-nm-lbl"
                                        onClick={(e: any) => {
                                          form.change(
                                            "building",
                                            building.building_name
                                          );
                                          setBuildings([]);
                                        }}
                                      >
                                        {building && building.building_name}
                                      </label>{" "}
                                      <br />
                                    </div>
                                  );
                                })}
                            </div>
                          ) : null}
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field
                      name="landmark"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("LANDMARK")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="pincode"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("PINCODE")}*</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field
                      name="address_mobile"
                      validate={ValidatorCustom.mobilePatternValidation}
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("ADDRESS_MOBILE")}</label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="address-bx">
                  <h5>
                    {t("EMPLOYMENT")} {t("DETAILS")}
                  </h5>
                </div>
                <div className="form-part">
                  <div className="flex-container">
                    <Field name="skill_set" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("SKILL")} {t("SET")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="profile_details" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("PROFILE")} {t("DETAILS")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="beneficiary_memeber_details" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("BENEFICIARY")} {t("MEMBER")} {t("DETAILS")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="relative1_details" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("RELATIVE")} {t("1")} {t("DETAILS")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="relative2_details" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("RELATIVE")} {t("2")} {t("DETAILS")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="existing_employment_details" rows={5}>
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="mb-mb-2">
                            {t("EXISTING")} {t("EMPLOYMENT")} {t("DETAILS")}
                          </label>
                          <textarea {...input} autoComplete="off" rows={5} />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="work_start_time">
                      {({ input, meta, options = dayTimeObjArr }) => (
                        <div className="flex-item">
                          <label>
                            {t("WORK")} {t("START")} {t("TIME")}
                          </label>
                          <SelectPicker
                            id="work_start_time_selector"
                            valueKey="value"
                            labelKey="label"
                            data={options}
                            value={input.value}
                            onSelect={(val) => input.onChange(val)}
                            onClean={() => input.onChange("")}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="work_end_time">
                      {({ input, meta, options = dayTimeObjArr }) => (
                        <div className="flex-item">
                          <label>
                            {t("WORK")} {t("END")} {t("TIME")}
                          </label>
                          <SelectPicker
                            id="work_end_time"
                            valueKey="value"
                            labelKey="label"
                            data={options}
                            value={input.value}
                            onSelect={(val) => input.onChange(val)}
                            onClean={() => input.onChange("")}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="week_off_day">
                      {({ input, meta, options = weekDaysObjArr }) => (
                        <div className="flex-item">
                          <label>
                            {t("WEEK")} {t("OFF")} {t("DAY")}
                          </label>
                          <SelectPicker
                            id="week_off_day_selector"
                            valueKey="value"
                            labelKey="label"
                            data={options}
                            value={input.value}
                            onSelect={(val) => input.onChange(val)}
                            onClean={() => input.onChange("")}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="birthday">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>{t("BIRTHDAY")}</label>
                          <DatePicker
                            value={input.value || null}
                            format={dateFormatObj.calendar_d_m_y}
                            name="birthday"
                            id="birthday"
                            onChange={(date) => input.onChange(date)}
                            onClean={() => input.onChange(null)}
                            cleanable
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="joining_date">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("JOINING")} {t("DATE")}
                          </label>
                          <DatePicker
                            value={input.value || null}
                            format={dateFormatObj.calendar_d_m_y}
                            name="joining_date"
                            id="joining_date"
                            onChange={(date) => input.onChange(date)}
                            onClean={() => input.onChange(null)}
                            cleanable
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="relieving_date">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("RELIEVING")} {t("DATE")}
                          </label>
                          <DatePicker
                            value={input.value || null}
                            format={dateFormatObj.calendar_d_m_y}
                            name="relieving_date"
                            id="relieving_date"
                            onChange={(date) => input.onChange(date)}
                            onClean={() => input.onChange(null)}
                            cleanable
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="create-action d-flex flex-end">
                  <Link to={ContentRoutes.USERS}>
                    <Button appearance="primary" color="red" type="button">
                      {t("CANCEL")}
                    </Button>
                  </Link>
                  <Button appearance="primary" color="green" type="submit">
                    {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                  </Button>
                  <Button
                    appearance="default"
                    type="reset"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      setFile("");
                      setUpdateUserImage("");
                      setUserIdProof("");
                      setIsUsernameAllowed(true);
                      setUserTypeSelected("");
                      setRoleTypeDynamically(form.getState().values.userType);
                      if (form.getState().values.country_id) {
                        handleCountryChange(form.getState().values.country_id);
                      }
                      if (form.getState().values.state_id) {
                        handleStateChange(form.getState().values.state_id);
                      }
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
              </form>
            )}
          />
        </Content>
      </Container>
    </div>
  );
}

export default NewUser;
